export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9106.bea4c42a.jpg";